import React from 'react';
import { Helmet } from "react-helmet-async";
import SectionHeader from '../../../../components/section-header/section-header';
import NotificationPanelNew from '../notification-panel/notification-panel-new';
import './notification-page.scss';
import { Route } from 'react-router-dom/cjs/react-router-dom.min';

const NotificationPageNew = () => {
    return (
        <div className="notification-panel" data-testid="notification-panel">
            <Helmet>
                <title>Triyo - Notifications</title>
            </Helmet>
            <div className="Notification-page">
                <SectionHeader title="Notifications"></SectionHeader>
                <Route path="/Notifications">
                    <NotificationPanelNew />
                </Route>
            </div>
        </div>
    );
}

export default NotificationPageNew;